type FeatureFlag = {
  enabled:     boolean
  description: string
}

export const FEATURE_FLAGS = {
  SOCIAL_ORDERS:    { enabled: true,  description: 'Social media order import via CSV'      },
  BOSTA_SHIPPING:   { enabled: true,  description: 'Bosta shipping provider integration'    },
  FIFO_INVENTORY:   { enabled: true,  description: 'FIFO inventory allocation'              },
  RECEIVING_SCAN:   { enabled: true,  description: 'Warehouse receiving scan workflow'      },
  DISPUTE_TIMER:    { enabled: true,  description: 'Return dispute timer tracking'          },
  DARK_MODE:        { enabled: false, description: 'Dark mode UI'                           },
  MULTI_LOCATION:   { enabled: false, description: 'Multi-location inventory'               },
  BULK_OPERATIONS:  { enabled: false, description: 'Bulk order operations'                  },
  ADVANCED_REPORTS: { enabled: false, description: 'Advanced analytics and custom reports'  },
  FORECAST_AI:      { enabled: false, description: 'AI-powered sales and revenue forecasts' },
} as const satisfies Record<string, FeatureFlag>

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS

export function isFeatureEnabled(flag: FeatureFlagKey): boolean {
  return FEATURE_FLAGS[flag].enabled
}
